export enum StorageStatus {
  UPLOADED = 'uploaded',
  ATTACHED = 'attached',
}

export enum VirusScanStatus {
  PENDING = 'in_progress',
  CLEAN = 'succeed',
  INFECTED = 'failed',
  NOT_SCANNABLE = 'not_scannable',
}

export const MAGIC_KEY = 'HBUPLD';

export const FILES_VALIDATION_FAILED = __(
  'One or more of your file(s) could not be processed. Please remove the file(s) and try again.',
);

export const FILE_VALIDATION_FAILED = __(
  'Your file could not be processed. Please remove the file and try again.',
);

export const FILES_VALIDATION_MALICIOUS_CONTENT = __(
  'One or more of your file(s) has been tagged as malicious content and cannot be uploaded. Please remove the file(s) and try again.',
);

export const FILE_VALIDATION_MALICIOUS_CONTENT = __(
  'Your file has been tagged as malicious content and cannot be uploaded. Please remove the file and try again.',
);

// This error is not meant to be displayed to the user. It is used to prevent
// submission of the form when files are still being processed or in an invalid
// state.
export const FILES_VALIDATION_PROCESSING_FILES =
  'FILES_VALIDATION_PROCESSING_FILES';

export const FILE_UPLOAD_ERROR = __('File %{name} could not be uploaded');

export const MALICIOUS_FILE = __('Malicious file');

export const UNKNOWN_VIRUS_SCAN_STATUS_ERROR = __(
  'Virus scan returned an unknown status',
);

export const FILE_TOO_LARGE_ERROR = __(
  'The maximum size you can upload is %{size} per file.',
);

export const ATTRIBUTES_SUFFIX = '_attachments_attributes';

export const VIRUS_SCAN_TIMEOUT = 300000;

export const VIRUS_SCAN_TIMEOUT_ERROR = `Virus scan timed out after ${
  VIRUS_SCAN_TIMEOUT / 1000
} seconds.`;
